import ExternalLink from '../../Components/assets/external-link.svg';

export function ExternalLinkIcon({ className = '' }: { className?: string }) {
    return <img className={className} src={ExternalLink} alt='External Link' />;
}
